import React, { useMemo, useState } from 'react';
import Masonry from './Masonry';

export default function ColorGradingPortfolio({ onBack }) {
  
  // 1. 记录当前被点击放大的视频
  const [activeVideo, setActiveVideo] = useState(null);

  // 2. 影视调色真实视频数据源 (已经换成你文件夹里真实存在的文件名！)
  const rawProjects = [
    { id: 1, videoUrl: "https://wangtao-portfolio.oss-cn-chengdu.aliyuncs.com/videos-2/%E4%BC%98%E8%A1%A3%E5%BA%93_1080_OUT4.mp4", type: "horizontal", title: "包装 / AE PS" }, 
    { id: 2, videoUrl: "https://wangtao-portfolio.oss-cn-chengdu.aliyuncs.com/videos-2/%E9%9A%86%E6%98%8C%E8%A7%84%E5%88%92%E7%89%872K.mp4", type: "horizontal", title: "包装 / AE C4D PS SD" },   
    { id: 3, videoUrl: "https://wangtao-portfolio.oss-cn-chengdu.aliyuncs.com/videos-2/%E4%B9%9D%E5%AF%A8%E6%B2%9F%E4%BA%BA%E6%B0%91%E6%A3%80%E5%AF%9F%E9%99%A2%E4%B8%93%E9%A2%98%E6%B1%87%E6%8A%A5%E7%89%87%28%E5%8C%85%E8%A3%85%29.mp4", type: "horizontal", title: "包装 / AE E3D" },
    { id: 4, videoUrl: "https://wangtao-portfolio.oss-cn-chengdu.aliyuncs.com/videos-2/%E8%AF%BA%E8%B4%9D%E8%BE%BE2.mp4", type: "horizontal", title: "MG / AE PS" },
    { id: 5, videoUrl: "https://wangtao-portfolio.oss-cn-chengdu.aliyuncs.com/videos-2/%E5%AE%88%E6%8A%A4.mp4", type: "horizontal", title: "全流程 / PR AE 达芬奇" },
    { id: 6, videoUrl: "https://wangtao-portfolio.oss-cn-chengdu.aliyuncs.com/videos-2/%E8%BE%93%E5%8F%98%E7%94%B5%E8%AF%81%E4%B9%A6.mp4", type: "horizontal", title: "包装 / C4D OC" },
    { id: 7, videoUrl: "https://wangtao-portfolio.oss-cn-chengdu.aliyuncs.com/videos-2/%E5%8C%97%E7%9B%98%E6%B1%9F-%E8%B0%83%E8%89%B2.mp4", type: "horizontal", title: "调色 / 达芬奇" },
    { id: 8, videoUrl: "https://wangtao-portfolio.oss-cn-chengdu.aliyuncs.com/videos-2/%E6%80%BB.mp4", type: "horizontal", title: "包装 / C4D OC" },
    { id: 9, videoUrl: "https://wangtao-portfolio.oss-cn-chengdu.aliyuncs.com/videos-2/%E4%BC%A0%E5%A5%87%E6%B5%B7%E7%9B%97.mp4", type: "horizontal", title: "全流程 / 拍摄 PR 达芬奇 AE PS" },

  ];

  // 3. 智能比例换算引擎
  const colorProjects = useMemo(() => {
    return rawProjects.map(item => {
      const calculatedHeight = item.type === 'vertical' ? 600 : 350;
      return {
        ...item,
        height: calculatedHeight
      };
    });
  }, []); 

  return (
    <div className="min-h-screen bg-[#050505] text-white pt-10 px-6 md:px-12 pb-24 overflow-x-hidden relative animate-[fadeIn_0.8s_ease-out]">
      
      {/* ================= 左上角：返回按钮 ================= */}
      <button 
        onClick={onBack}
        className="fixed top-8 left-8 z-50 flex items-center gap-2 text-neutral-400 hover:text-white transition-colors duration-300 group backdrop-blur-md bg-black/20 px-4 py-2 rounded-full border border-white/10"
      >
        <svg className="w-5 h-5 transition-transform duration-300 group-hover:-translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path></svg>
        <span className="font-mono text-sm tracking-widest">BACK</span>
      </button>

      {/* ================= 页面抬头 (Teal & Orange 青橙色调渐变) ================= */}
      <div className="max-w-[1600px] mx-auto mt-20 mb-16 space-y-4 text-center md:text-left pl-0 md:pl-8 border-l-0 md:border-l-4 border-amber-500">
        <h1 className="text-5xl md:text-7xl font-black text-transparent bg-clip-text bg-gradient-to-r from-cyan-600 via-teal-500 to-amber-500 tracking-tighter">
          影视制作
        </h1>
        <p className="text-neutral-500 font-mono tracking-widest uppercase text-sm">
          AE // PR // 达芬奇 //
        </p>
      </div>

      {/* ================= 瀑布流组件 (复用完美的底层框架) ================= */}
      <div className="max-w-[1600px] mx-auto">
        <Masonry 
          items={colorProjects} 
          ease="power3.out"
          duration={0.8}
          // 接收点击事件，激活视频播放器
          onItemClick={(item) => setActiveVideo(item)} 
        />
      </div>

      {/* ================= 🎬 终极视觉魔法：全屏毛玻璃视频播放器 ================= */}
      {activeVideo && (
        <div 
          className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/80 backdrop-blur-2xl transition-all"
          onClick={() => setActiveVideo(null)} 
        >
          {/* 右上角关闭按钮 */}
          <button 
            className="absolute top-8 right-8 p-4 text-white/50 hover:text-white transition-colors duration-300 hover:rotate-90"
            onClick={() => setActiveVideo(null)}
          >
            <svg className="w-10 h-10" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M6 18L18 6M6 6l12 12" /></svg>
          </button>

          {/* 视频容器 */}
          <div 
            className="relative w-[90%] md:w-[80%] max-w-7xl max-h-[85vh] bg-black rounded-xl md:rounded-3xl overflow-hidden shadow-[0_0_80px_rgba(255,150,0,0.15)] border border-white/10"
            onClick={(e) => e.stopPropagation()} 
          >
            <video 
              src={activeVideo.videoUrl}
              className="w-full h-full max-h-[85vh] object-contain"
              autoPlay  
              loop
              playsInline
              muted    
              controls  // 🚀 新增这一行！
            />
          </div>
        </div>
      )}

    </div>
  );
}